function Footer() {
  return (
    <div className="text-center mt-16 p-6">
      Copyright {new Date().getFullYear()} BPPR Magazine - All rights reserved.
    </div>
  );
}

export default Footer;
